import { MemoryRouter } from 'react-router';
import { launchEntriesOf } from '../features/navigation/index.js';
import type { TelegramRuntime } from '../shared/telegram/index.js';
import { OutsideTelegram } from './outside-telegram/outside-telegram.js';
import { QueryProvider } from './query-provider.js';
import { AppRouter } from './router/app-router.js';
import styles from './app.module.css';

type AppProps = {
  runtime: TelegramRuntime;
};

/**
 * Read once, at launch: the address is where a button under a bot message says which screen to
 * open, and nothing later in the session changes it.
 */
const launchEntries = launchEntriesOf(window.location.search);

/**
 * The router keeps its history in memory on purpose (design note A8). Telegram hands the launch
 * data over in the address hash (#tgWebAppData=...), so a hash router would overwrite it and the
 * very next request would fail to identify the person.
 */
export const App = ({ runtime }: AppProps) => {
  if (runtime.status === 'unavailable') {
    return <OutsideTelegram reason={runtime.reason} />;
  }

  return (
    <QueryProvider>
      <MemoryRouter initialEntries={launchEntries} initialIndex={launchEntries.length - 1}>
        <div className={styles.app}>
          <AppRouter />
        </div>
      </MemoryRouter>
    </QueryProvider>
  );
};
